import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { identityKeys } from '@/lib/queries/identity';
import { ConnectedAccountsClient } from './-components/ConnectedAccountsClient';

export const Route = createFileRoute('/_authed/settings/connected/')({
  component: SettingsConnectedPage,
});

function SettingsConnectedPage() {
  const query = useQuery({
    ...identityKeys.connectedAccounts(),
    retry: false,
  });
  return <ConnectedAccountsClient loadFailed={query.isError} />;
}
